<template>
  <div class="Authorize">
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="ant-advanced-search-form ">
      <el-form-item label="客户名称：" prop="name">
        <el-input v-model="queryParams.name" placeholder="请输入客户名称" clearable @keyup.enter.native="handleQuery"
          @change="$forceUpdate()"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">新增授权</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" element-loading-text="加载中" :data="list">
      <el-table-column label="序号" align="center" type="index" width="80" />
      <el-table-column label="客户名称" align="center" prop="name" />
      <el-table-column label="授权数据集" align="center" prop="datasetName" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total > queryParams.pageSize" :total="total" :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize" @pagination="_getList" />

    <el-dialog :title="dialogTitle" :visible.sync="showDialog" width="800px" append-to-body custom-class="elDialogBase">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="客户名称:" prop="orgId">
          <el-select v-model="form.orgId" placeholder="请选择客户" filterable clearable size="small" @change="userChange">
            <el-option v-for="(item, index) in selectlist" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="数据集:" class="isRequired">
          <div class="dataSelect">
            <div class="flxL">
              <el-input placeholder="输入关键字进行过滤" v-model="filterText" @change="$forceUpdate()" class="mb10"> </el-input>
              <el-tree ref="tree" node-key="id" show-checkbox default-expand-all class="filter-tree" :data="treeData"
                :props="defaultProps" :default-checked-keys="checkKeys" :filter-node-method="filterNode"
                @check-change="getCheck">
              </el-tree>
            </div>
            <div class="flxR ml10">
              <div class="preShow">
                <span>已选{{ checkNodes.length }}</span>
                <span class="clear" @click="clearNode">清空</span>
              </div>
              <div class="nodeList">
                <div class="node" v-for="(item,index) in checkNodes" :key="index">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as API_Dataset from "@/api/dataset/dataset";

export default {
  data() {
    return {
      userRole: null,
      queryParams: {
        name: null,
        pageNum: 1,
        pageSize: 10,
      },
      list: [],
      total: 0,
      loading: false,
      filterText: '',
      treeData: [],
      checkKeys: [],
      checkNodes: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      dialogTitle: '',
      showDialog: false,
      selectlist: [],
      form: {
        orgId: null,
      },
      rules: {
				orgId: [{ required: true, message: "请选择客户", trigger: "change", }],
				// authSourceIds: [{ required: true, message: "请选择数据集", trigger: "change", }],
      }
    };
  },

  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
  methods: {
    _getLongList() {
      let api_url = this.userRole == 'ADMIN' ? 'getOrgList' : 'getGroupList'
      API_Dataset[api_url]({ pageNum: 1,  pageSize: 100}).then(res => {
        console.log(res.data.data);
        if(res.success) {
          this.selectlist = res.data.data.list.map(item => {
            return {
              ...item,
              id: item.id || item.orgId
            }
          })
        }
      })
    },
    _getList() {
      let api_url = this.userRole == 'ADMIN' ? 'getOrgList' : 'getGroupList'
      API_Dataset[api_url](this.queryParams).then(res => {
        console.log(res);
        if(res.success) {
          let data = res.data.data
          this.list = data.list
          this.total = data.total
        }
      })
    },
    handleQuery() {
			this.queryParams.pageNum = 1;
			this._getList();
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
			this.handleQuery();
    },
    getTree() {
      const modelInfo = localStorage.getItem('dataset-tree')
      this.treeData = JSON.parse(modelInfo)
      console.log(this.treeData);
    },
    handleAdd() {
      this.dialogTitle = '新增授权'
      this.$set(this.form, 'orgId', null)
      this.showDialog = true
      this.checkKeys = [];
      this.checkNodes = []
      this.$nextTick(()=>{
        this.$refs.form.resetFields();
      })
      this.form.authSourceIds = this.checkNodes
      if(this.$refs.tree) this.$refs.tree.setCheckedKeys([],true)
      this.$forceUpdate()
    },
    handleEdit(e) {
      console.log(e);
      this.form = JSON.parse(JSON.stringify(e))
      if( this.userRole != 'ADMIN') {
        this.form.orgId = this.form.id
      }
      console.log(this.form);
      this.dialogTitle = '授权客户'
      this.showDialog = true
      this.userRole == 'ADMIN' ? this.getUserEcho(e.orgId) : this.getUserEcho(e.id)
    },
    getUserEcho(id) {
      let params = {
        authSourceType: 'dataset',
        authTargetType: this.userRole == 'ADMIN' ? 'org' : 'group',
        targetId: id
      }
      API_Dataset.getListById(params).then(res => {
        console.log(res.data);
        this.checkNodes = res.data
        let checkKeys = res.data.map(item => item.id)
        this.checkKeys = checkKeys
        this.form.authSourceIds = res.data
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(checkKeys,true)
        })
      })
    },
    userChange(e) {
      console.log(e);
      this.getUserEcho(e)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getCheck() {
      this.checkKeys = this.$refs.tree.getCheckedKeys();
      this.checkNodes = this.$refs.tree.getCheckedNodes().filter((ele) => ele.modelInnerType != "group")
      this.form.authSourceIds = this.checkNodes
    },
    clearNode() {
      this.checkKeys = []
      this.checkNodes = []
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([],true)
      })
    },
    confirm() {
      if(!this.form.authSourceIds.length) {
        this.$message({ message: '请选择数据集', type: 'error' });
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log(this.form);
          this._setOrgAuth()
        } else {
          console.log('error submit!!');
          this.$message({
            message: '填写数据不全或数据有误',
            type: 'error'
          });
          return false;
        }
      });
    },
    _setOrgAuth() {
      // let params = this.form
      // params.authSourceType = 'dataset'
      // params.authTargetType = 'org'
      // API_Dataset.setOrgAuth(params).then(res => {
      //   this.$message.success("操作成功");
      //   this.showDialog = false
      //   this.resetQuery()
      // })
      let params = {
        authSourceType: 'dataset',
        targetId: this.form.orgId,
        sourceIds: this.form.authSourceIds.map(item => item.id),
        authTargetType: this.userRole == 'ADMIN' ? 'org' : 'group',
      }
      // console.log(params);
      // return
      API_Dataset.setAuthNew(params).then(res => {
        this.$message.success("操作成功");
        this.showDialog = false
        this.resetQuery()
      })
    }
  },
  created() {
    this.userRole = this.$store.state.user.roles.length && this.$store.state.user.roles[0].name || ''
    this.getTree()
    this._getList()
    this._getLongList()
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .el-tree-node__expand-icon.is-leaf {
    visibility: hidden;
  }
</style>
<style lang='less' scoped>

.Authorize {
  padding: 20px;
  height: calc(100vh - 160px);
  overflow-y: auto;
}
.dataSelect {
  display: flex;
  height: 600px;
  width: 100%;
  .flxL,.flxR {
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
  }
  .flxL {
    border: 1px solid #f4f4f4;
    padding: 10px;
  }
  .flxR {
    border: 1px solid #f4f4f4;
    .preShow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      line-height: 48px;
      background-color: #f5f5f5;
    }
    .clear {
      color: #1890FF;
      cursor: pointer;
    }
    .node {
      padding: 0 20px;
      line-height: 36px;
    }
  }
}
</style>
